import { z } from 'zod/v3';

export const ChangedBySchema = z.object({
  id: z.number(),
  username: z.string(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
});
